(function () {
  'use strict';

  if (window.__kailaColorPaletteInit) return;
  window.__kailaColorPaletteInit = true;

  var LOCAL_SAVE_PREFIX = 'color_guide_saved_';
  var PALETTE_SAVE_PREFIX = 'color_palette_saved_';
  var PENDING_PALETTE_SAVE_KEY = 'color_palette_pending_save';
  var PALETTE_AUTO_SAVE_PARAM = 'color_palette_auto_save';
  var MANUAL_MODEL_KEY_PREFIX = 'color_palette_manual_model_';
  var DEFAULT_MIN_NEUTRALS = 2;
  var PALETTE_SLOT_COUNT = 6;
  var PALETTE_ROLE = {
    TRUE_NEUTRAL: 'true-neutral',
    COLORED_NEUTRAL: 'colored-neutral',
    ACCENT: 'accent'
  };
  var SLOT_ROLE_LABELS = {
    'true-neutral': 'True neutral',
    'colored-neutral': 'Colored neutral',
    accent: 'Accent'
  };
  var WARDROBE_ROLE_TAG = {
    light_neutral: 'light-neutral',
    dark_neutral: 'dark-neutral',
    coloured_neutral: 'colored-neutral',
    supporting_color: 'supporting-color',
    signature_color: 'signature-color'
  };
  var DEFAULT_PALETTE_SLOT_RULES = [
    { label: 'Dark neutral', allowedRoles: ['dark_neutral'] },
    { label: 'Light neutral', allowedRoles: ['light_neutral'] },
    { label: 'Light / coloured neutral', allowedRoles: ['light_neutral', 'coloured_neutral'] },
    { label: 'Coloured / supporting', allowedRoles: ['coloured_neutral', 'supporting_color'] },
    { label: 'Signature color', allowedRoles: ['signature_color', 'supporting_color'] },
    { label: 'Supporting / signature', allowedRoles: ['supporting_color', 'signature_color'] }
  ];
  var DEFAULT_PALETTE_CONSTRAINTS = {
    darkNeutralExact: 1,
    neutralMin: 2,
    colouredNeutralMin: 1,
    signatureMin: 1,
    signatureMax: 2,
    neutralMinLightnessGap: 3
  };
  var STYLE_DIRECTIONS = [
    { id: 'minimal', label: 'Minimal' },
    { id: 'earthy', label: 'Earthy' },
    { id: 'elegant', label: 'Elegant' },
    { id: 'romantic', label: 'Romantic' },
    { id: 'creative', label: 'Creative' },
    { id: 'fresh', label: 'Fresh' },
    { id: 'dramatic', label: 'Dramatic' },
    { id: 'professional', label: 'Professional' },
    { id: 'scandinavian', label: 'Scandinavian' }
  ];
  var SUITABILITY_LEVELS = [
    {
      value: 1,
      label: 'Style only',
      description: 'Ignore personal coloring � the palette follows your chosen wardrobe style.'
    },
    {
      value: 2,
      label: 'Soft filter',
      description: 'Exclude your weakest colors, but your chosen style still leads.'
    },
    {
      value: 3,
      label: 'Balanced',
      description: 'Blend your chosen style with colors that suit your profile.'
    }
  ];
  var WARDROBE_ROLE_LABELS = {
    dark_neutral: 'Dark neutral',
    light_neutral: 'Light neutral',
    coloured_neutral: 'Coloured neutral',
    supporting_color: 'Supporting',
    signature_color: 'Signature'
  };
  var HUE_FAMILY_TAGS = ['green', 'yellow', 'red', 'orange', 'pink', 'blue', 'purple'];
  var TRUE_NEUTRAL_MIN_LIGHTNESS_GAP = 3;

  var COLOR_RATING_TIERS = [
    { maxDistance: 2.5, stars: 5, label: 'Excellent' },
    { maxDistance: 4, stars: 4, label: 'Very good' },
    { maxDistance: 5.5, stars: 3, label: 'Good' },
    { maxDistance: 7.5, stars: 2, label: 'Can work depending on the outfit' },
    { maxDistance: Infinity, stars: 1, label: 'Probably not your strongest colors' }
  ];

  // Matches design_generation/library/color_library.py (_SHOPIFY_ADJACENT_MIN_DELTA_E).
  var MIN_SIMILAR_DELTA_E = 14;
  var MIN_SIMILAR_DELTA_E_STRICT = 10;
  var WARDROBE_MAX_HUE_DIFF = 30;
  var WARDROBE_MAX_LIGHTNESS_DIFF = 0.18;
  var WARDROBE_MUTED_SATURATION = 0.55;
  var NEUTRAL_MAX_HUE_DIFF = 35;
  var NEUTRAL_MAX_LIGHTNESS_DIFF = 0.22;
  var NEUTRAL_MUTED_MAX_SATURATION = 0.15;
  var NEUTRAL_MUTED_MIN_DELTA_E = 18;
  var BLACK_WHITE_VENDOR_CODES = { '001': true, '999': true };

  var CATEGORY_WEIGHTS = {
    skin_color: 0.45,
    natural_hair_color: 0.35,
    eye_color: 0.2
  };

  var SCORES = {
    natural_hair_color: {
      black: { warmth: -1, lightness: -5, contrast: 5 },
      'very-dark-brown': { warmth: 1, lightness: -4, contrast: 4 },
      'dark-brown': { warmth: 2, lightness: -3, contrast: 3 },
      'medium-brown': { warmth: 2, lightness: -1, contrast: 1 },
      'light-brown': { warmth: 3, lightness: 1, contrast: -1 },
      'dark-blonde': { warmth: 2, lightness: 3, contrast: -2 },
      blonde: { warmth: 1, lightness: 5, contrast: -4 },
      'light-medium-red': { warmth: 5, lightness: 4, contrast: -3 },
      'red-auburn': { warmth: 5, lightness: -1, contrast: 2 },
      'platinum-white': { warmth: -2, lightness: 5, contrast: 4 }
    },
    eye_color: {
      'dark-brown': { warmth: 2, contrast: 4 },
      'medium-brown': { warmth: 2, contrast: 2 },
      hazel: { warmth: 4, contrast: 1 },
      green: { warmth: 1, contrast: 0 },
      blue: { warmth: -3, contrast: 0 },
      grey: { warmth: -4, contrast: -1 }
    },
    skin_color: {
      'very-deep': { lightness: -5 },
      deep: { lightness: -4 },
      tan: { lightness: -2 },
      medium: { lightness: 0 },
      'light-medium': { lightness: 1 },
      light: { lightness: 3 },
      fair: { lightness: 4 },
      'very-fair': { lightness: 5 }
    }
  };

  var COLOR_MODELS = [
    { name: 'Aino', slug: 'aino', warmth: -2, lightness: 10, contrast: 1 },
    { name: 'Bailey', slug: 'bailey', warmth: 9, lightness: 3, contrast: 7 },
    { name: 'Cecilia', slug: 'cecilia', warmth: 1, lightness: -7, contrast: 14 },
    { name: 'Emilie', slug: 'emilie', warmth: 3, lightness: -1, contrast: 9 },
    { name: 'Freya', slug: 'freya', warmth: -3, lightness: 10, contrast: 2 },
    { name: 'Ksenia', slug: 'ksenia', warmth: -1, lightness: 3, contrast: 5 },
    { name: 'Lucia', slug: 'lucia', warmth: 1, lightness: -7, contrast: 14 },
    { name: 'Mei', slug: 'mei', warmth: 1, lightness: -2, contrast: 14 },
    { name: 'Niamh', slug: 'niamh', warmth: 2, lightness: 14, contrast: -2 },
    { name: 'Hafsatu', slug: 'hafsatu', warmth: 1, lightness: -10, contrast: 14 },
    { name: 'Priya', slug: 'priya', warmth: 1, lightness: -7, contrast: 14 },
    { name: 'Rima', slug: 'rima', warmth: 1, lightness: -4, contrast: 14 },
    { name: 'Oko', slug: 'oko', warmth: 2, lightness: -6, contrast: 14 },
    { name: 'Yoki', slug: 'yoki', warmth: 1, lightness: -7, contrast: 14 },
    { name: 'Zofia', slug: 'zofia', warmth: -2, lightness: 2, contrast: 9 }
  ];

  var MODEL_COLOR_SCALE = { warmth: 9, lightness: 14, contrast: 14 };

  var MALE_MODEL_PARTNERS = {
    aino: 'einar',
    bailey: 'james',
    cecilia: 'ananda',
    emilie: 'paolo',
    freya: 'lars',
    ksenia: 'florian',
    lucia: 'thiago',
    mei: 'minho',
    niamh: 'nikolai',
    hafsatu: 'diallo',
    priya: 'karim',
    rima: 'william',
    oko: 'selam',
    yoki: 'chaska',
    zofia: 'ivan'
  };

  var ANSWER_LABELS = {
    natural_hair_color: {
      black: 'Black',
      'very-dark-brown': 'Very dark brown',
      'dark-brown': 'Dark brown',
      'medium-brown': 'Medium brown',
      'light-brown': 'Light brown',
      'dark-blonde': 'Dark blonde',
      'light-medium-red': 'Light/medium red',
      'red-auburn': 'Red/auburn',
      blonde: 'Blonde',
      'platinum-white': 'Platinum/white'
    },
    eye_color: {
      'dark-brown': 'Dark brown',
      'medium-brown': 'Medium brown',
      hazel: 'Hazel',
      green: 'Green',
      blue: 'Blue',
      grey: 'Grey',
      black: 'Black',
      amber: 'Amber'
    },
    skin_color: {
      'very-deep': 'Very deep',
      deep: 'Deep',
      tan: 'Tan',
      medium: 'Medium',
      'light-medium': 'Light-medium',
      light: 'Light',
      fair: 'Fair',
      'very-fair': 'Very fair',
      'medium-deep': 'Tan',
      'medium-light': 'Light-medium'
    }
  };

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getConfig(root) {
    return {
      loggedIn: root.getAttribute('data-customer-logged-in') === 'true',
      customerId: root.getAttribute('data-customer-id') || '',
      quizUrl: root.getAttribute('data-quiz-url') || '/pages/color-guide',
      palettePageUrl: root.getAttribute('data-palette-page') || '/pages/color-palette',
      preferencesUrl: root.getAttribute('data-preferences-url') || '/pages/preferences',
      saveUrl: root.getAttribute('data-save-url') || '/apps/ayami-color-guide/palette-save',
      loginUrl: root.getAttribute('data-login-url') || '/account/login',
      registerUrl: root.getAttribute('data-register-url') || '/account/register',
      catalogUrl: root.getAttribute('data-catalog-url') || '',
      outfitAssetsUrl: root.getAttribute('data-outfit-assets-url') || ''
    };
  }

  function getModelSlug(context) {
    if (!context) return null;
    if (context.outfitModelSlug) return context.outfitModelSlug;
    if (context.selectedModel && context.selectedModel.slug) {
      var model = resolveSelectedModel({ selectedModel: context.selectedModel });
      if (model) return model.slug;
    }
    return null;
  }

  function mountOutfitGallery(root, context, state, config) {
    if (!state.outfitsVisible || !state.hasGenerated) return;

    var grid = root.querySelector('[data-palette-outfits-grid]');
    if (!grid) return;

    if (!window.kailaPaletteOutfits) {
      grid.innerHTML = '<p class="color-palette-outfits__error">Outfit preview script failed to load. Re-upload <code>color-palette-outfits.js</code> to your theme assets.</p>';
      return;
    }

    if (!config.outfitAssetsUrl) {
      grid.innerHTML = '<p class="color-palette-outfits__error">Outfit assets are not configured yet.</p>';
      return;
    }

    window.kailaPaletteOutfits.render(grid, {
      slots: state.slots,
      modelSlug: getModelSlug(context),
      assetsUrl: config.outfitAssetsUrl
    });
  }

  function renderOutfitsSection(state, context) {
    if (!state.hasGenerated) return '';

    var modelName =
      context && context.resolvedModel && context.resolvedModel.name
        ? context.resolvedModel.name
        : '';
    var modelHint = modelName ? ' Shown on ' + modelName : ' Shown on your model match.';
    if (context && context.quizModelName && modelName) {
      modelHint +=
        ' (women\u2019s equivalent of your color-guide match, ' + context.quizModelName + ').';
    }

    return (
      '<section class="color-palette__outfits' + (state.outfitsVisible ? '' : ' hidden') + '" data-palette-outfits>' +
      '<h2 class="color-palette__outfits-heading title h2">Your palette in outfits</h2>' +
      '<p class="color-palette__hint">Six looks built from your palette colors.' + modelHint + '</p>' +
      '<div class="color-palette-outfits__grid" data-palette-outfits-grid aria-live="polite"></div>' +
      '</section>'
    );
  }

  function readSavedPreferencesFromPage() {
    var scriptEl = document.getElementById('ColorGuideSavedData');
    if (!scriptEl || !scriptEl.textContent.trim()) return null;
    try {
      return JSON.parse(scriptEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function loadLocalSave(customerId) {
    var keys = [];
    if (customerId) keys.push(LOCAL_SAVE_PREFIX + customerId);
    keys.push(LOCAL_SAVE_PREFIX + 'active');
    for (var i = 0; i < keys.length; i++) {
      var raw = null;
      try {
        raw = sessionStorage.getItem(keys[i]) || localStorage.getItem(keys[i]);
      } catch (e) {}
      if (!raw) continue;
      try {
        return JSON.parse(raw);
      } catch (e) {}
    }
    return null;
  }

  function loadColorGuideData(config) {
    var payload = readSavedPreferencesFromPage();
    if (!payload) payload = loadLocalSave(config.customerId);
    if (!payload || !payload.colorMatches || !payload.colorMatches.length) return null;
    return payload;
  }

  function serializePaletteState(state) {
    var savedAt = new Date().toISOString();
    return {
      hasGenerated: !!state.hasGenerated,
      styleDirection: state.styleDirection || 'minimal',
      suitabilityLevel: state.suitabilityLevel || 1,
      styleSuggestions: state.styleSuggestions || '',
      slots: state.slots.map(function (slot) {
        return {
          slotId: slot.slotId,
          slotIndex: typeof slot.slotIndex === 'number' ? slot.slotIndex : null,
          allowedRoles: slot.allowedRoles ? slot.allowedRoles.slice() : null,
          role: slot.role || null,
          label: slot.label || null,
          locked: !!slot.locked,
          assignedWardrobeRole: slot.assignedWardrobeRole || null,
          vendorCode: slot.color && slot.color.vendorCode ? slot.color.vendorCode : null,
          ratingStars: slot.rating && slot.rating.stars ? slot.rating.stars : null,
          ratingLabel: slot.rating && slot.rating.label ? slot.rating.label : null,
          distance: typeof slot.distance === 'number' ? slot.distance : null
        };
      }),
      savedAt: savedAt,
      saved_at: savedAt
    };
  }

  function normalizeSavedPalette(raw) {
    if (!raw || !raw.hasGenerated || !Array.isArray(raw.slots) || !raw.slots.length) {
      return null;
    }
    return {
      hasGenerated: true,
      styleDirection: raw.styleDirection || 'minimal',
      suitabilityLevel: raw.suitabilityLevel || 1,
      styleSuggestions: raw.styleSuggestions || '',
      slots: raw.slots,
      savedAt: raw.savedAt || raw.saved_at || null,
      saved_at: raw.saved_at || raw.savedAt || null
    };
  }

  function readSavedPaletteFromPage() {
    var scriptEl = document.getElementById('ColorPaletteSavedData');
    if (!scriptEl || !scriptEl.textContent.trim()) return null;
    try {
      return normalizeSavedPalette(JSON.parse(scriptEl.textContent));
    } catch (e) {
      return null;
    }
  }

  function buildPaletteSavePayload(state) {
    return { palette: serializePaletteState(state) };
  }

  function clearPendingPaletteSave() {
    try {
      sessionStorage.removeItem(PENDING_PALETTE_SAVE_KEY);
    } catch (e) {}
  }

  function readPendingPaletteSave() {
    try {
      var raw = sessionStorage.getItem(PENDING_PALETTE_SAVE_KEY);
      if (!raw) return null;
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function storePendingPaletteSave(payload) {
    try {
      sessionStorage.setItem(PENDING_PALETTE_SAVE_KEY, JSON.stringify(payload));
    } catch (e) {}
  }

  function showPaletteSaveHint(root, message, isError) {
    var hint = root.querySelector('[data-palette-save-hint]');
    if (!hint) return;
    hint.textContent = message;
    hint.classList.toggle('hidden', !message);
    hint.classList.toggle('is-error', !!isError);
  }

  function savePalettePreferences(config, payload) {
    payload.palette.saved_at = payload.palette.saved_at || new Date().toISOString();
    payload.palette.savedAt = payload.palette.saved_at;

    if (config.saveUrl) {
      return fetch(config.saveUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify(payload)
      }).then(function (response) {
        if (!response.ok) {
          var error = new Error('Save failed');
          error.status = response.status;
          error.url = config.saveUrl;
          throw error;
        }
        clearPendingPaletteSave();
        return { ok: true, mode: 'profile' };
      });
    }

    clearPendingPaletteSave();
    return Promise.resolve({ ok: true, mode: 'local' });
  }

  function redirectToLoginForPaletteSave(config) {
    var returnPath = config.palettePageUrl || window.location.pathname;
    var separator = returnPath.indexOf('?') >= 0 ? '&' : '?';
    var returnUrl = returnPath + separator + PALETTE_AUTO_SAVE_PARAM + '=1';
    window.location.href = config.loginUrl + '?return_url=' + encodeURIComponent(returnUrl);
  }

  function showStyleSubmitHint(root, message, isError) {
    var hint = root.querySelector('[data-palette-style-submit-hint]');
    if (!hint) return;
    hint.textContent = message;
    hint.classList.toggle('hidden', !message);
    hint.classList.toggle('is-error', !!isError);
  }

  function handleSubmitStyleSuggestions(root, config, state) {
    var field = root.querySelector('[data-palette-style-suggestions]');
    if (!field || !state) return;

    var text = (field.value || '').trim();
    if (!text) {
      showStyleSubmitHint(root, 'Please enter at least one style.', true);
      return;
    }

    state.styleSuggestions = text;
    savePaletteState(config, state);

    if (!config.loggedIn) {
      showStyleSubmitHint(root, 'Thanks � saved on this device.', false);
      return;
    }

    if (!state.hasGenerated) {
      showStyleSubmitHint(root, 'Generate a palette first, then submit your suggestion.', true);
      return;
    }

    showStyleSubmitHint(root, 'Submitting�', false);
    savePalettePreferences(config, buildPaletteSavePayload(state))
      .then(function () {
        showStyleSubmitHint(root, 'Thanks � we received your suggestion.', false);
      })
      .catch(function () {
        showStyleSubmitHint(root, 'Could not submit right now. Saved on this device only.', true);
      });
  }

  function handleSavePalette(root, config, state) {
    if (!state || !state.hasGenerated) return;

    var payload = buildPaletteSavePayload(state);
    savePaletteState(config, state);

    if (!config.loggedIn) {
      storePendingPaletteSave(payload);
      redirectToLoginForPaletteSave(config);
      return;
    }

    showPaletteSaveHint(root, 'Saving�', false);
    savePalettePreferences(config, payload)
      .then(function (result) {
        savePaletteState(config, state);
        if (config.preferencesUrl) {
          var suffix = result.mode === 'local' ? 'palette_saved=1&local=1' : 'palette_saved=1';
          window.location.href = config.preferencesUrl +
            (config.preferencesUrl.indexOf('?') >= 0 ? '&' : '?') + suffix;
          return;
        }
        showPaletteSaveHint(root, 'Palette saved.', false);
      })
      .catch(function (error) {
        savePaletteState(config, state);
        var message = 'Could not sync to your profile';
        if (error && error.status === 404) {
          message += ' (404 on ' + (error.url || config.saveUrl) + ')';
        } else if (error && error.status) {
          message += ' (HTTP ' + error.status + ')';
        } else {
          message += ' (server unavailable)';
        }
        message += '. Saved on this device only.';
        if (config.preferencesUrl) {
          window.location.href = config.preferencesUrl + '?palette_saved=1&local=1';
          return;
        }
        showPaletteSaveHint(root, message, true);
      });
  }

  function savePaletteState(config, state) {
    if (!state || !state.hasGenerated) return;
    var serialized = JSON.stringify(serializePaletteState(state));
    try {
      localStorage.setItem(PALETTE_SAVE_PREFIX + 'active', serialized);
      if (config.customerId) {
        localStorage.setItem(PALETTE_SAVE_PREFIX + config.customerId, serialized);
      }
    } catch (e) {}
  }

  function loadSavedPaletteState(customerId) {
    var fromPage = readSavedPaletteFromPage();
    if (fromPage) return fromPage;

    var keys = [];
    if (customerId) keys.push(PALETTE_SAVE_PREFIX + customerId);
    keys.push(PALETTE_SAVE_PREFIX + 'active');
    for (var i = 0; i < keys.length; i++) {
      var raw = null;
      try {
        raw = localStorage.getItem(keys[i]);
      } catch (e) {}
      if (!raw) continue;
      try {
        var payload = JSON.parse(raw);
        return normalizeSavedPalette(payload);
      } catch (e) {}
    }
    return null;
  }

  function hydratePaletteState(saved, catalog) {
    var colorsByCode = {};
    catalog.colors.forEach(function (color) {
      colorsByCode[color.vendorCode] = color;
    });

    var template = buildFixedPaletteSlots(catalog);
    var slots = template.map(function (slot, index) {
      var savedSlot = (saved.slots && saved.slots[index]) || {};
      var color = savedSlot.vendorCode ? colorsByCode[savedSlot.vendorCode] : null;
      var rating = null;
      if (savedSlot.ratingStars) {
        rating = {
          stars: savedSlot.ratingStars,
          label: savedSlot.ratingLabel || ''
        };
      }
      return {
        slotId: savedSlot.slotId || slot.slotId,
        slotIndex: index,
        allowedRoles: slot.allowedRoles.slice(),
        role: color ? displayRoleForColor(color, slot.allowedRoles) : slot.role,
        label: slot.label,
        locked: !!savedSlot.locked,
        color: color,
        rating: rating,
        distance: typeof savedSlot.distance === 'number' ? savedSlot.distance : null,
        assignedWardrobeRole:
          savedSlot.assignedWardrobeRole ||
          (color ? resolveAssignedWardrobeRole(color, slot.allowedRoles, null) : null)
      };
    });

    return {
      hasGenerated: true,
      styleDirection: saved.styleDirection || 'minimal',
      suitabilityLevel: saved.suitabilityLevel || 1,
      styleSuggestions: saved.styleSuggestions || '',
      slots: slots,
      outfitsVisible: false
    };
  }

  function readCatalogFromPage() {
    var scriptEl = document.getElementById('AbujaPaletteCatalog');
    if (!scriptEl || !scriptEl.textContent.trim()) return null;
    try {
      return JSON.parse(scriptEl.textContent);
    } catch (e) {
      return null;
    }
  }

  function validateCatalog(payload) {
    if (!payload || !Array.isArray(payload.colors) || !payload.colors.length) {
      return null;
    }
    return payload;
  }

  function loadCatalog(config) {
    var inline = validateCatalog(readCatalogFromPage());
    if (inline) {
      return Promise.resolve(inline);
    }

    if (!config.catalogUrl) {
      return Promise.reject(new Error('Missing Abuja palette catalog'));
    }

    return fetch(config.catalogUrl, { credentials: 'same-origin' })
      .then(function (response) {
        if (!response.ok) throw new Error('Could not load color catalog');
        return response.text();
      })
      .then(function (text) {
        if (/^\s*(<!doctype html|<html[\s>])/i.test(text)) {
          throw new Error('Color catalog asset not found');
        }
        var payload = validateCatalog(JSON.parse(text));
        if (!payload) throw new Error('Invalid color catalog');
        return payload;
      });
  }

  function normalizeAnswers(rawAnswers) {
    if (Array.isArray(rawAnswers)) return rawAnswers;
    if (!rawAnswers || typeof rawAnswers !== 'object') return [];

    return Object.keys(rawAnswers).map(function (key) {
      var entry = rawAnswers[key];
      if (entry && typeof entry === 'object') {
        return {
          questionKey: entry.questionKey || key,
          value: entry.value,
          label: entry.label
        };
      }
      return {
        questionKey: key,
        value: entry,
        label: entry
      };
    });
  }

  function getAnswerValue(answers, questionKey) {
    for (var i = 0; i < answers.length; i++) {
      if (answers[i].questionKey === questionKey) return answers[i].value;
    }
    return null;
  }

  function getAnswerLabel(questionKey, value) {
    var labels = ANSWER_LABELS[questionKey];
    if (labels && labels[value]) return labels[value];
    return value || '';
  }

  function findModelBySlug(slug) {
    if (!slug) return null;
    for (var i = 0; i < COLOR_MODELS.length; i++) {
      if (COLOR_MODELS[i].slug === slug) return COLOR_MODELS[i];
    }
    return null;
  }

  function findTypeSlugForPartnerSlug(partnerSlug) {
    if (!partnerSlug) return null;
    var partner = partnerSlug.toLowerCase();
    for (var typeSlug in MALE_MODEL_PARTNERS) {
      if (MALE_MODEL_PARTNERS.hasOwnProperty(typeSlug) && MALE_MODEL_PARTNERS[typeSlug] === partner) {
        return typeSlug;
      }
    }
    return partnerSlug;
  }

  function isMalePartnerSlug(slug) {
    if (!slug) return false;
    if (findModelBySlug(slug)) return false;
    var typeSlug = findTypeSlugForPartnerSlug(slug);
    return typeSlug !== slug && !!findModelBySlug(typeSlug);
  }

  function resolveOutfitModelSlug(model) {
    if (!model) return null;
    return model.slug;
  }

  function loadManualModelSelection(customerId) {
    var keys = [];
    if (customerId) keys.push(MANUAL_MODEL_KEY_PREFIX + customerId);
    keys.push(MANUAL_MODEL_KEY_PREFIX + 'active');
    for (var i = 0; i < keys.length; i++) {
      var raw = null;
      try {
        raw = sessionStorage.getItem(keys[i]) || localStorage.getItem(keys[i]);
      } catch (e) {}
      if (!raw) continue;
      return raw;
    }
    return null;
  }

  function saveManualModelSelection(customerId, slug) {
    try {
      sessionStorage.setItem(MANUAL_MODEL_KEY_PREFIX + 'active', slug);
      localStorage.setItem(MANUAL_MODEL_KEY_PREFIX + 'active', slug);
      if (customerId) {
        sessionStorage.setItem(MANUAL_MODEL_KEY_PREFIX + customerId, slug);
        localStorage.setItem(MANUAL_MODEL_KEY_PREFIX + customerId, slug);
      }
    } catch (e) {}
  }

  function refreshSlotRatings(slots, profile) {
    if (!profile || !Array.isArray(slots)) return;
    slots.forEach(function (slot) {
      if (!slot.color) return;
      var distance = profileDistance(profile, slot.color);
      slot.distance = distance;
      slot.rating = getRating(distance);
    });
  }

  function buildProfileContextFromModel(model, catalog) {
    if (!model) return null;
    var modelProfile = normalizeModelProfile(model);
    var voteColors = filterVoteColors(catalog);
    return {
      answers: [],
      selectedModel: { slug: model.slug, name: model.name, typeSlug: model.slug },
      resolvedModel: model,
      quizModelName: null,
      outfitModelSlug: resolveOutfitModelSlug(model),
      targetProfile: modelProfile,
      rankedColors: rankCatalogColors(voteColors, modelProfile),
      catalog: catalog,
      minNeutralColors: catalog.minNeutralColors || DEFAULT_MIN_NEUTRALS,
      profileSource: 'manual-model'
    };
  }

  function resolveProfileContext(guidePayload, manualModelSlug, catalog) {
    if (guidePayload) {
      var context = buildProfileContext(guidePayload, catalog);
      if (context) return context;
    }

    var model = findModelBySlug(manualModelSlug);
    if (model) return buildProfileContextFromModel(model, catalog);
    return null;
  }

  function calculateScores(answers) {
    var weighted = { warmth: 0, lightness: 0, contrast: 0 };
    var weightSums = { warmth: 0, lightness: 0, contrast: 0 };

    answers.forEach(function (answer) {
      var weight = CATEGORY_WEIGHTS[answer.questionKey];
      if (!weight) return;

      var category = SCORES[answer.questionKey];
      if (!category) return;

      var points = category[answer.value];
      if (!points) return;

      if (typeof points.warmth === 'number') {
        weighted.warmth += points.warmth * weight;
        weightSums.warmth += weight;
      }
      if (typeof points.lightness === 'number') {
        weighted.lightness += points.lightness * weight;
        weightSums.lightness += weight;
      }
      if (typeof points.contrast === 'number') {
        weighted.contrast += points.contrast * weight;
        weightSums.contrast += weight;
      }
    });

    var totals = { warmth: 0, lightness: 0, contrast: 0 };
    ['warmth', 'lightness', 'contrast'].forEach(function (dimension) {
      if (weightSums[dimension] > 0) {
        totals[dimension] = Math.round((weighted[dimension] / weightSums[dimension]) * 10) / 10;
      }
    });

    return totals;
  }

  function normalizeModelProfile(model) {
    return {
      warmth: Math.round((model.warmth / MODEL_COLOR_SCALE.warmth) * 5 * 10) / 10,
      lightness: Math.round((model.lightness / MODEL_COLOR_SCALE.lightness) * 5 * 10) / 10,
      contrast: Math.round((model.contrast / MODEL_COLOR_SCALE.contrast) * 5 * 10) / 10
    };
  }

  function buildColorTargetProfile(customerProfile, model) {
    if (!model) return customerProfile;
    var normalizedModel = normalizeModelProfile(model);
    var target = {};
    ['warmth', 'lightness', 'contrast'].forEach(function (dimension) {
      target[dimension] = Math.round(
        ((customerProfile[dimension] + normalizedModel[dimension]) / 2) * 10
      ) / 10;
    });
    return target;
  }

  function profileDistance(profile, color) {
    var warmthDelta = profile.warmth - color.warmth;
    var lightnessDelta = profile.lightness - color.lightness;
    var contrastDelta = profile.contrast - color.contrast;
    return Math.sqrt(
      warmthDelta * warmthDelta +
      lightnessDelta * lightnessDelta +
      contrastDelta * contrastDelta
    );
  }

  function hasTag(color, tag) {
    return !!(color && color.tags && color.tags.indexOf(tag) !== -1);
  }

  function isBlackOrWhite(color) {
    return !!(color && color.vendorCode && BLACK_WHITE_VENDOR_CODES[color.vendorCode]);
  }

  function isNeutralColor(color) {
    return (
      isBlackOrWhite(color) ||
      hasTag(color, 'neutral') ||
      hasTag(color, 'light-neutral') ||
      hasTag(color, 'dark-neutral')
    );
  }

  function getPaletteConstraints(catalog) {
    if (catalog && catalog.paletteConstraints) {
      return Object.assign({}, DEFAULT_PALETTE_CONSTRAINTS, catalog.paletteConstraints);
    }
    return Object.assign({}, DEFAULT_PALETTE_CONSTRAINTS);
  }

  function getSlotRules(catalog) {
    if (catalog && Array.isArray(catalog.slotRules) && catalog.slotRules.length === PALETTE_SLOT_COUNT) {
      return catalog.slotRules.map(function (rule) {
        return {
          label: rule.label,
          allowedRoles: (rule.allowedRoles || []).slice()
        };
      });
    }
    return DEFAULT_PALETTE_SLOT_RULES.map(function (rule) {
      return {
        label: rule.label,
        allowedRoles: rule.allowedRoles.slice()
      };
    });
  }

  function colorHasWardrobeRole(color, wardrobeRole) {
    if (!color) return false;
    if (Array.isArray(color.roles) && color.roles.indexOf(wardrobeRole) !== -1) return true;
    return hasTag(color, WARDROBE_ROLE_TAG[wardrobeRole]);
  }

  function primaryDisplayRoleForAllowedRoles(allowedRoles) {
    if (
      allowedRoles.indexOf('dark_neutral') !== -1 ||
      allowedRoles.indexOf('light_neutral') !== -1
    ) {
      return PALETTE_ROLE.TRUE_NEUTRAL;
    }
    if (allowedRoles.indexOf('coloured_neutral') !== -1) {
      return PALETTE_ROLE.COLORED_NEUTRAL;
    }
    return PALETTE_ROLE.ACCENT;
  }

  function displayRoleForColor(color, allowedRoles) {
    if (!color) return PALETTE_ROLE.ACCENT;
    var i;
    for (i = 0; i < allowedRoles.length; i++) {
      if (colorHasWardrobeRole(color, allowedRoles[i])) {
        return primaryDisplayRoleForAllowedRoles([allowedRoles[i]]);
      }
    }
    if (color.paletteRole) return color.paletteRole;
    return primaryDisplayRoleForAllowedRoles(allowedRoles);
  }

  function buildFixedPaletteSlots(catalog) {
    return getSlotRules(catalog).map(function (rule, index) {
      return {
        slotId: 'slot-' + (index + 1),
        slotIndex: index,
        allowedRoles: rule.allowedRoles.slice(),
        role: primaryDisplayRoleForAllowedRoles(rule.allowedRoles),
        label: rule.label,
        locked: false,
        color: null,
        rating: null,
        distance: null
      };
    });
  }

  function getColorPaletteRole(color) {
    if (!color) return PALETTE_ROLE.ACCENT;
    if (color.paletteRole) return color.paletteRole;
    if (colorHasWardrobeRole(color, 'light_neutral') || colorHasWardrobeRole(color, 'dark_neutral')) {
      return PALETTE_ROLE.TRUE_NEUTRAL;
    }
    if (colorHasWardrobeRole(color, 'coloured_neutral')) {
      return PALETTE_ROLE.COLORED_NEUTRAL;
    }
    return PALETTE_ROLE.ACCENT;
  }

  function getPerceptualLightness(color) {
    if (!color) return null;
    var lab = getColorLab(color);
    if (lab) return lab.L;
    var hsl = getColorHsl(color);
    if (hsl) return hsl.l * 100;
    return typeof color.lightness === 'number' ? ((color.lightness + 5) / 10) * 100 : null;
  }

  function getColorHueFamily(color) {
    if (!color) return null;
    var i;
    for (i = 0; i < HUE_FAMILY_TAGS.length; i++) {
      if (hasTag(color, HUE_FAMILY_TAGS[i])) return HUE_FAMILY_TAGS[i];
    }
    if (colorHasWardrobeRole(color, 'light_neutral') || colorHasWardrobeRole(color, 'dark_neutral')) {
      return null;
    }
    var hsl = getColorHsl(color);
    if (!hsl || hsl.s < 0.1) return 'achromatic';
    var h = hsl.h;
    if (h < 25 || h >= 335) return 'red';
    if (h < 55) return 'orange';
    if (h < 75) return 'yellow';
    if (h < 165) return 'green';
    if (h < 250) return 'blue';
    if (h < 290) return 'purple';
    return 'pink';
  }

  function paletteHasHueFamily(paletteColors, family) {
    if (!family) return false;
    for (var i = 0; i < paletteColors.length; i++) {
      if (getColorHueFamily(paletteColors[i]) === family) return true;
    }
    return false;
  }

  function getPaletteConstraintState(slots) {
    var state = {
      darkNeutralCount: 0,
      neutralCount: 0,
      colouredNeutralCount: 0,
      signatureCount: 0
    };
    getPaletteColorsFromSlots(slots).forEach(function (color) {
      if (colorHasWardrobeRole(color, 'dark_neutral')) state.darkNeutralCount += 1;
      if (colorHasWardrobeRole(color, 'light_neutral') || colorHasWardrobeRole(color, 'dark_neutral')) {
        state.neutralCount += 1;
      }
      if (colorHasWardrobeRole(color, 'coloured_neutral')) state.colouredNeutralCount += 1;
      if (colorHasWardrobeRole(color, 'signature_color')) state.signatureCount += 1;
    });
    return state;
  }

  function slotCanSatisfyRole(slotIndex, slots, wardrobeRole) {
    var slot = slots[slotIndex];
    if (!slot || slot.locked) return false;
    return slot.allowedRoles.indexOf(wardrobeRole) !== -1;
  }

  function countRemainingRoleSlots(slots, fromIndex, wardrobeRole) {
    var count = 0;
    for (var i = fromIndex; i < slots.length; i++) {
      if (slotCanSatisfyRole(i, slots, wardrobeRole)) count += 1;
    }
    return count;
  }

  function getSlotPickRequirements(slotIndex, slots, constraints) {
    var slot = slots[slotIndex];
    var allowedRoles = slot.allowedRoles.slice();
    var requiredRole = null;
    var state = getPaletteConstraintState(slots);

    var remainingColouredSlots = countRemainingRoleSlots(slots, slotIndex, 'coloured_neutral');
    var remainingSignatureSlots = countRemainingRoleSlots(slots, slotIndex, 'signature_color');
    var needsColoured = state.colouredNeutralCount === 0 && remainingColouredSlots === 1;
    var needsSignature = state.signatureCount === 0 && remainingSignatureSlots === 1;

    if (needsColoured && needsSignature) {
      if (allowedRoles.indexOf('coloured_neutral') !== -1) {
        requiredRole = 'coloured_neutral';
      } else if (allowedRoles.indexOf('signature_color') !== -1) {
        requiredRole = 'signature_color';
      }
    } else if (needsColoured && allowedRoles.indexOf('coloured_neutral') !== -1) {
      requiredRole = 'coloured_neutral';
    } else if (needsSignature && allowedRoles.indexOf('signature_color') !== -1) {
      requiredRole = 'signature_color';
    }

    if (state.signatureCount >= constraints.signatureMax) {
      allowedRoles = allowedRoles.filter(function (role) {
        return role !== 'signature_color';
      });
    }

    return {
      allowedRoles: allowedRoles,
      requiredRole: requiredRole
    };
  }

  function colorMatchesSlotRoles(color, allowedRoles, requiredRole) {
    if (requiredRole && !colorHasWardrobeRole(color, requiredRole)) return false;
    var i;
    for (i = 0; i < allowedRoles.length; i++) {
      if (colorHasWardrobeRole(color, allowedRoles[i])) return true;
    }
    return false;
  }

  function buildLightNeutralLightnessConstraint(slots, gap) {
    var darkSlot = slots[0];
    if (!darkSlot || !darkSlot.color) return {};
    var previousLightness = getPerceptualLightness(darkSlot.color);
    if (typeof previousLightness !== 'number') return {};
    return { minLightness: previousLightness + gap };
  }

  function slotRoleClass(role) {
    if (role === PALETTE_ROLE.TRUE_NEUTRAL) return 'color-palette__slot--true-neutral';
    if (role === PALETTE_ROLE.COLORED_NEUTRAL) return 'color-palette__slot--colored-neutral';
    if (role === PALETTE_ROLE.ACCENT) return 'color-palette__slot--accent';
    return '';
  }

  function parseHexRgb(hex) {
    if (!hex) return null;
    var value = String(hex).replace('#', '').trim();
    if (value.length !== 6) return null;
    var r = parseInt(value.slice(0, 2), 16);
    var g = parseInt(value.slice(2, 4), 16);
    var b = parseInt(value.slice(4, 6), 16);
    if (!Number.isFinite(r) || !Number.isFinite(g) || !Number.isFinite(b)) return null;
    return { r: r / 255, g: g / 255, b: b / 255 };
  }

  function linearSrgbChannel(channel) {
    return channel <= 0.04045 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
  }

  function rgbToLab(r, g, b) {
    var R = linearSrgbChannel(r);
    var G = linearSrgbChannel(g);
    var B = linearSrgbChannel(b);
    var X = R * 0.4124564 + G * 0.3575761 + B * 0.1804375;
    var Y = R * 0.2126729 + G * 0.7151522 + B * 0.0721750;
    var Z = R * 0.0193339 + G * 0.1191920 + B * 0.9503041;
    var Xn = 0.95047;
    var Yn = 1.0;
    var Zn = 1.08883;
    var delta = 6 / 29;

    function f(t) {
      return t > Math.pow(delta, 3) ? Math.pow(t, 1 / 3) : t / (3 * delta * delta) + 4 / 29;
    }

    var fx = f(X / Xn);
    var fy = f(Y / Yn);
    var fz = f(Z / Zn);
    return {
      L: 116 * fy - 16,
      a: 500 * (fx - fy),
      b: 200 * (fy - fz)
    };
  }

  function getColorLab(color) {
    if (!color) return null;
    if (color._lab) return color._lab;
    var rgb = parseHexRgb(color.hex);
    color._lab = rgb ? rgbToLab(rgb.r, rgb.g, rgb.b) : null;
    return color._lab;
  }

  function deltaE76(lab1, lab2) {
    var dL = lab1.L - lab2.L;
    var da = lab1.a - lab2.a;
    var db = lab1.b - lab2.b;
    return Math.sqrt(dL * dL + da * da + db * db);
  }

  function getColorHsl(color) {
    if (!color) return null;
    if (color._hsl) return color._hsl;
    var rgb = parseHexRgb(color.hex);
    if (!rgb) return null;

    var r = rgb.r;
    var g = rgb.g;
    var b = rgb.b;
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var h = 0;
    var l = (max + min) / 2;
    var s = 0;

    if (max !== min) {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      if (max === r) h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
      else if (max === g) h = ((b - r) / d + 2) / 6;
      else h = ((r - g) / d + 4) / 6;
    }

    color._hsl = { h: h * 360, s: s, l: l };
    return color._hsl;
  }

  function hueDifference(h1, h2) {
    var diff = Math.abs(h1 - h2);
    return Math.min(diff, 360 - diff);
  }

  function colorsAreTooSimilar(colorA, colorB) {
    if (!colorA || !colorB) return false;
    if (colorA.vendorCode && colorB.vendorCode && colorA.vendorCode === colorB.vendorCode) return true;

    var labA = getColorLab(colorA);
    var labB = getColorLab(colorB);
    var deltaE = labA && labB ? deltaE76(labA, labB) : Infinity;

    if (deltaE < MIN_SIMILAR_DELTA_E_STRICT) return true;

    var hslA = getColorHsl(colorA);
    var hslB = getColorHsl(colorB);

    if (
      hslA &&
      hslB &&
      isNeutralColor(colorA) &&
      isNeutralColor(colorB) &&
      hslA.s < NEUTRAL_MUTED_MAX_SATURATION &&
      hslB.s < NEUTRAL_MUTED_MAX_SATURATION &&
      deltaE < NEUTRAL_MUTED_MIN_DELTA_E
    ) {
      return true;
    }

    if (hslA && hslB) {
      var hueDiff = hueDifference(hslA.h, hslB.h);
      var lightDiff = Math.abs(hslA.l - hslB.l);

      if (
        !isBlackOrWhite(colorA) &&
        !isBlackOrWhite(colorB) &&
        hueDiff < WARDROBE_MAX_HUE_DIFF &&
        lightDiff < WARDROBE_MAX_LIGHTNESS_DIFF &&
        (hslA.s < WARDROBE_MUTED_SATURATION || hslB.s < WARDROBE_MUTED_SATURATION)
      ) {
        return true;
      }

      if (
        isNeutralColor(colorA) &&
        isNeutralColor(colorB) &&
        hueDiff < NEUTRAL_MAX_HUE_DIFF &&
        lightDiff < NEUTRAL_MAX_LIGHTNESS_DIFF
      ) {
        return true;
      }
    }

    return deltaE < MIN_SIMILAR_DELTA_E;
  }

  function minDeltaEToPalette(color, paletteColors) {
    var lab = getColorLab(color);
    if (!lab || !paletteColors.length) return Infinity;

    var minDelta = Infinity;
    paletteColors.forEach(function (otherColor) {
      var otherLab = getColorLab(otherColor);
      if (!otherLab) return;
      var delta = deltaE76(lab, otherLab);
      if (delta < minDelta) minDelta = delta;
    });
    return minDelta;
  }

  function isTooSimilarToPalette(color, paletteColors) {
    if (!paletteColors.length) return false;
    for (var i = 0; i < paletteColors.length; i++) {
      if (colorsAreTooSimilar(color, paletteColors[i])) return true;
    }
    return false;
  }

  function filterDistinctMatches(matches, paletteColors) {
    return matches.filter(function (match) {
      return !isTooSimilarToPalette(match.color, paletteColors);
    });
  }

  function pickMostDistinctMatch(matches, paletteColors) {
    if (!matches.length) return null;

    var scored = matches.map(function (match) {
      var minDelta = minDeltaEToPalette(match.color, paletteColors);
      var tooSimilar = isTooSimilarToPalette(match.color, paletteColors);
      return {
        match: match,
        minDelta: minDelta,
        tooSimilar: tooSimilar
      };
    }).sort(function (a, b) {
      if (a.tooSimilar !== b.tooSimilar) return a.tooSimilar - b.tooSimilar;
      if (b.minDelta !== a.minDelta) return b.minDelta - a.minDelta;
      if (b.match.rating.stars !== a.match.rating.stars) return b.match.rating.stars - a.match.rating.stars;
      return a.match.distance - b.match.distance;
    });

    var best = scored[0];
    if (!best.tooSimilar) {
      var strong = scored.filter(function (entry) {
        return !entry.tooSimilar && entry.minDelta >= best.minDelta - 2;
      });
      if (strong.length) {
        return weightedRandomPick(buildPreferredMatchPool(strong.map(function (entry) {
          return entry.match;
        })));
      }
    }

    return weightedRandomPick(buildPreferredMatchPool([best.match]));
  }

  function getRating(distance) {
    for (var i = 0; i < COLOR_RATING_TIERS.length; i++) {
      if (distance <= COLOR_RATING_TIERS[i].maxDistance) {
        return COLOR_RATING_TIERS[i];
      }
    }
    return COLOR_RATING_TIERS[COLOR_RATING_TIERS.length - 1];
  }

  function renderStarIcons(count) {
    var stars = '';
    for (var i = 0; i < count; i++) stars += '\u2B50';
    return stars;
  }

  function filterVoteColors(catalog) {
    if (!catalog || !Array.isArray(catalog.colors)) return [];
    return catalog.colors.filter(function (color) {
      return color.inColorVote !== false;
    });
  }

  function shuffleArray(list) {
    for (var i = list.length - 1; i > 0; i--) {
      var j = Math.floor(Math.random() * (i + 1));
      var tmp = list[i];
      list[i] = list[j];
      list[j] = tmp;
    }
    return list;
  }

  function buildWardrobeCandidatePool(catalogColors, profile) {
    var pool = catalogColors.map(function (color) {
      var distance = profileDistance(profile, color);
      return {
        color: color,
        distance: distance,
        rating: getRating(distance)
      };
    });
    return shuffleArray(pool);
  }

  function rankCatalogColors(catalogColors, profile) {
    return catalogColors.map(function (color) {
      var distance = profileDistance(profile, color);
      return {
        color: color,
        distance: distance,
        rating: getRating(distance)
      };
    }).sort(function (a, b) {
      if (b.rating.stars !== a.rating.stars) return b.rating.stars - a.rating.stars;
      return a.distance - b.distance;
    });
  }

  function resolveSelectedModel(payload) {
    if (!payload || !payload.selectedModel) return null;
    var selected = payload.selectedModel;
    if (selected.typeSlug) {
      return findModelBySlug(selected.typeSlug);
    }

    var slug = selected.slug;
    if (!slug) return null;

    var femaleModel = findModelBySlug(slug);
    if (femaleModel) return femaleModel;

    var typeSlug = findTypeSlugForPartnerSlug(slug);
    return findModelBySlug(typeSlug);
  }

  function resolveModelFromAnswers(payload) {
    if (!payload) return null;
    var answers = normalizeAnswers(payload.answers);
    var modelValue = getAnswerValue(answers, 'selected_model');
    if (!modelValue) return null;
    return resolveSelectedModel({ selectedModel: { slug: modelValue } });
  }

  function buildProfileContext(payload, catalog) {
    var answers = normalizeAnswers(payload.answers);
    var profileAnswers = answers.filter(function (answer) {
      return ['natural_hair_color', 'eye_color', 'skin_color'].indexOf(answer.questionKey) !== -1;
    });

    if (profileAnswers.length < 3) return null;

    var scores = calculateScores(profileAnswers);
    var resolvedModel = resolveSelectedModel(payload) || resolveModelFromAnswers(payload);
    var targetProfile = buildColorTargetProfile(scores, resolvedModel);
    var voteColors = filterVoteColors(catalog);
    var rankedColors = rankCatalogColors(voteColors, targetProfile);
    var quizModelName = null;

    if (payload.selectedModel && payload.selectedModel.name && resolvedModel) {
      var quizSlug = String(payload.selectedModel.slug || '').toLowerCase();
      if (
        quizSlug &&
        quizSlug !== resolvedModel.slug &&
        isMalePartnerSlug(quizSlug)
      ) {
        quizModelName = payload.selectedModel.name;
      }
    }

    return {
      answers: profileAnswers,
      selectedModel: resolvedModel
        ? { slug: resolvedModel.slug, name: resolvedModel.name, typeSlug: resolvedModel.slug }
        : payload.selectedModel || null,
      resolvedModel: resolvedModel,
      quizModelName: quizModelName,
      outfitModelSlug: resolvedModel ? resolveOutfitModelSlug(resolvedModel) : null,
      targetProfile: targetProfile,
      rankedColors: rankedColors,
      catalog: catalog,
      minNeutralColors: catalog.minNeutralColors || DEFAULT_MIN_NEUTRALS,
      profileSource: 'color-guide'
    };
  }

  function weightedRandomPick(matches) {
    if (!matches.length) return null;

    var totalWeight = 0;
    var weights = matches.map(function (match, index) {
      var stars = match.rating ? match.rating.stars : 1;
      var weight = Math.pow(stars, 4) / Math.sqrt(index + 1);
      totalWeight += weight;
      return weight;
    });

    var roll = Math.random() * totalWeight;
    var cumulative = 0;
    for (var i = 0; i < matches.length; i++) {
      cumulative += weights[i];
      if (roll <= cumulative) return matches[i];
    }
    return matches[matches.length - 1];
  }

  function buildPreferredMatchPool(matches) {
    if (!matches.length) return matches;

    var topStars = matches[0].rating.stars;
    for (var minStars = topStars; minStars >= 1; minStars--) {
      var pool = matches.filter(function (match) {
        return match.rating.stars >= minStars;
      });
      if (pool.length >= 2 || minStars === 1) return pool;
    }
    return matches;
  }

  function pickMatchForWardrobeSlot(slotIndex, slots, rankedColors, usedVendorCodes, paletteColors, catalog) {
    var slot = slots[slotIndex];
    var constraints = getPaletteConstraints(catalog);
    var requirements = getSlotPickRequirements(slotIndex, slots, constraints);
    var lightnessGaps = [constraints.neutralMinLightnessGap || TRUE_NEUTRAL_MIN_LIGHTNESS_GAP, 1, 0];
    var passes = [{ useRequirements: true }, { useRequirements: false }];

    for (var passIndex = 0; passIndex < passes.length; passIndex++) {
      var useRequirements = passes[passIndex].useRequirements;
      var allowedRoles = useRequirements
        ? requirements.allowedRoles
        : slot.allowedRoles.slice();
      var requiredRole = useRequirements ? requirements.requiredRole : null;

      for (var gapIndex = 0; gapIndex < lightnessGaps.length; gapIndex++) {
        var options = {};
        if (slotIndex === 1) {
          options = buildLightNeutralLightnessConstraint(slots, lightnessGaps[gapIndex]);
        }

        var filtered = rankedColors.filter(function (match) {
          if (usedVendorCodes[match.color.vendorCode]) return false;
          if (!colorMatchesSlotRoles(match.color, allowedRoles, requiredRole)) return false;

          var family = getColorHueFamily(match.color);
          if (family && paletteHasHueFamily(paletteColors, family)) return false;

          var lightness = getPerceptualLightness(match.color);
          if (typeof lightness === 'number') {
            if (typeof options.minLightness === 'number' && lightness <= options.minLightness) return false;
            if (typeof options.maxLightness === 'number' && lightness >= options.maxLightness) return false;
          }
          return true;
        });

        if (!filtered.length) continue;

        var distinct = filterDistinctMatches(filtered, paletteColors);
        if (distinct.length) {
          return weightedRandomPick(buildPreferredMatchPool(distinct));
        }

        var fallback = pickMostDistinctMatch(filtered, paletteColors);
        if (fallback) return fallback;
      }
    }

    return null;
  }

  function getPaletteColorsFromSlots(slots) {
    return slots
      .filter(function (slot) {
        return !!slot.color;
      })
      .map(function (slot) {
        return slot.color;
      });
  }

  function createEmptySlots(catalog) {
    return buildFixedPaletteSlots(catalog);
  }

  function applyMatchToSlot(slot, match, assignedRole) {
    if (!match) return;
    slot.color = match.color;
    slot.rating = match.rating;
    slot.distance = match.distance;
    slot.role = displayRoleForColor(match.color, slot.allowedRoles);
    slot.assignedWardrobeRole =
      assignedRole || resolveAssignedWardrobeRole(match.color, slot.allowedRoles, null);
  }

  function resolveAssignedWardrobeRole(color, allowedRoles, requiredRole) {
    if (window.KailaPaletteEngine && window.KailaPaletteEngine.resolveAssignedWardrobeRole) {
      return window.KailaPaletteEngine.resolveAssignedWardrobeRole(color, allowedRoles, requiredRole);
    }
    if (requiredRole && colorHasWardrobeRole(color, requiredRole)) return requiredRole;
    var i;
    for (i = 0; i < allowedRoles.length; i++) {
      if (colorHasWardrobeRole(color, allowedRoles[i])) return allowedRoles[i];
    }
    return allowedRoles[0] || null;
  }

  function formatWardrobeRole(role) {
    if (!role) return '';
    return WARDROBE_ROLE_LABELS[role] || role.replace(/_/g, ' ');
  }

  function formatStyleDirection(styleDirection) {
    var selected = styleDirection || 'minimal';
    var i;
    for (i = 0; i < STYLE_DIRECTIONS.length; i++) {
      if (STYLE_DIRECTIONS[i].id === selected) return STYLE_DIRECTIONS[i].label;
    }
    return selected;
  }

  function renderStyleDirectionPicker(state) {
    var selected = state.styleDirection || 'minimal';
    var html =
      '<section class="color-palette__style" aria-labelledby="color-palette-style-heading">' +
      '<h2 id="color-palette-style-heading" class="color-palette__style-title">Choose your wardrobe style</h2>' +
      '<p class="color-palette__style-intro">Choose the kind of wardrobe you want to build.</p>' +
      '<div class="color-palette__style-grid" role="list">';

    STYLE_DIRECTIONS.forEach(function (direction) {
      var isSelected = direction.id === selected;
      html +=
        '<button type="button" class="color-palette__style-card' +
        (isSelected ? ' is-selected' : '') +
        '" data-style-direction="' +
        escapeHtml(direction.id) +
        '" aria-pressed="' +
        (isSelected ? 'true' : 'false') +
        '" role="listitem">' +
        escapeHtml(direction.label) +
        '</button>';
    });

    html += '</div></section>';
    return html;
  }

  function prepareSlotsForEngine(slots) {
    return slots.map(function (slot) {
      var next = Object.assign({}, slot);
      if (next.locked && next.color) {
        next.assignedWardrobeRole =
          next.assignedWardrobeRole ||
          resolveAssignedWardrobeRole(next.color, next.allowedRoles, null);
      }
      return next;
    });
  }

  function buildEngineOptions(slots, isFirstGenerate, styleDirection, suitabilityLevel) {
    if (isFirstGenerate) {
      return {
        isRegenerate: false,
        styleDirection: styleDirection || 'minimal',
        suitabilityLevel: suitabilityLevel || 1
      };
    }

    var previousVendorCodeBySlot = slots.map(function (slot) {
      if (slot.locked || !slot.color || !slot.color.vendorCode) return null;
      return slot.color.vendorCode;
    });

    return {
      isRegenerate: true,
      previousVendorCodeBySlot: previousVendorCodeBySlot,
      styleDirection: styleDirection || 'minimal',
      suitabilityLevel: suitabilityLevel || 1
    };
  }

  function generatePalette(slots, candidatePool, catalog, isFirstGenerate, styleDirection, suitabilityLevel) {
    var engineOptions = buildEngineOptions(
      slots,
      isFirstGenerate !== false,
      styleDirection,
      suitabilityLevel
    );
    if (window.KailaPaletteEngine && window.KailaPaletteEngine.generatePalette) {
      return window.KailaPaletteEngine.generatePalette(slots, candidatePool, catalog, Object.assign(
        { displayRoleForColor: displayRoleForColor },
        engineOptions
      ));
    }

    var nextSlots = slots.map(function (slot) {
      return {
        slotId: slot.slotId,
        slotIndex: slot.slotIndex,
        allowedRoles: slot.allowedRoles.slice(),
        role: slot.role,
        label: slot.label,
        locked: !!slot.locked,
        color: slot.locked && slot.color ? slot.color : null,
        rating: slot.locked && slot.rating ? slot.rating : null,
        distance: slot.locked && typeof slot.distance === 'number' ? slot.distance : null
      };
    });

    var usedVendorCodes = {};
    nextSlots.forEach(function (slot) {
      if (slot.color && slot.color.vendorCode) {
        usedVendorCodes[slot.color.vendorCode] = true;
      }
    });

    nextSlots.forEach(function (slot, slotIndex) {
      if (slot.locked && slot.color) return;

      var paletteColors = getPaletteColorsFromSlots(nextSlots);
      var match = pickMatchForWardrobeSlot(
        slotIndex,
        nextSlots,
        rankedColors,
        usedVendorCodes,
        paletteColors,
        catalog
      );
      if (!match) return;

      applyMatchToSlot(slot, match);
      usedVendorCodes[match.color.vendorCode] = true;
    });

    return nextSlots;
  }

  function renderLoginPrompt(config) {
    return (
      '<div class="color-palette__empty-state">' +
      '<p>Log in to build a palette from your color guide results.</p>' +
      '<div class="color-palette__actions">' +
      '<a class="button" href="' + escapeHtml(config.loginUrl) + '">Log in</a>' +
      '<a class="button button--secondary" href="' + escapeHtml(config.registerUrl) + '">Create account</a>' +
      '</div>' +
      '</div>'
    );
  }

  function getSuitabilityLevelMeta(level) {
    var value = level || 1;
    var i;
    for (i = 0; i < SUITABILITY_LEVELS.length; i++) {
      if (SUITABILITY_LEVELS[i].value === value) return SUITABILITY_LEVELS[i];
    }
    return SUITABILITY_LEVELS[0];
  }

  function renderPaletteIntroHint(suitabilityLevel) {
    var level = suitabilityLevel || 1;
    var starsHint =
      level === 1
        ? 'Stars show model suitability for reference only.'
        : level === 2
          ? 'Weak one-star colors are excluded; stars show how each shade suits you.'
          : 'Stars guide generation toward colors that suit you while keeping your chosen style.';
    return (
      'Choose a wardrobe style, then tap <strong>Generate palette</strong> for six coherent Abuja colors. ' +
      starsHint +
      ' Lock favourites; regenerating changes every unlocked color.'
    );
  }

  function renderEmptyState(config) {
    return (
      '<div class="color-palette__empty-state">' +
      '<p>Complete the color guide quiz first so we can use your hair, skin, eye color, and model match � or pick a model below to get started without the quiz.</p>' +
      '<div class="color-palette__actions">' +
      '<a class="button" href="' + escapeHtml(config.quizUrl) + '">Take the color guide quiz</a>' +
      '</div>' +
      '</div>'
    );
  }

  function renderModelPickerGrid(selectedSlug) {
    var html = '<div class="color-palette__model-grid" role="list">';
    COLOR_MODELS.forEach(function (model) {
      var isSelected = model.slug === selectedSlug;
      html +=
        '<button type="button" class="color-palette__model-card' +
        (isSelected ? ' is-selected' : '') +
        '" data-palette-model="' +
        escapeHtml(model.slug) +
        '" aria-pressed="' +
        (isSelected ? 'true' : 'false') +
        '" role="listitem">' +
        escapeHtml(model.name) +
        '</button>';
    });
    html += '</div>';
    return html;
  }

  function renderProfileSetup(config) {
    return (
      '<div class="color-palette__setup">' +
      '<h2 class="color-palette__setup-title">Start with your color profile</h2>' +
      '<p class="color-palette__setup-intro">Take the color guide quiz for a profile matched to your hair, skin, and eyes. ' +
      'Or pick a women\u2019s model to stand in for now � outfit previews use women\u2019s models only for the moment.</p>' +
      '<div class="color-palette__actions">' +
      '<a class="button" href="' + escapeHtml(config.quizUrl) + '">Take the color guide quiz</a>' +
      '</div>' +
      '<h3 class="color-palette__setup-subtitle">Or pick a model</h3>' +
      renderModelPickerGrid('') +
      '</div>'
    );
  }

  function renderSuitabilitySlider(state) {
    var level = state.suitabilityLevel || 1;
    var meta = getSuitabilityLevelMeta(level);
    return (
      '<section class="color-palette__suitability" aria-labelledby="color-palette-suitability-heading">' +
      '<h2 id="color-palette-suitability-heading" class="color-palette__suitability-title">Personal color match</h2>' +
      '<p class="color-palette__suitability-intro">How much should we consider your skin tone, eye color, hair color, and model type?</p>' +
      '<div class="color-palette__suitability-control">' +
      '<input type="range" class="color-palette__suitability-slider" min="1" max="3" step="1" value="' +
      level +
      '" data-palette-suitability aria-valuemin="1" aria-valuemax="3" aria-valuenow="' +
      level +
      '" aria-label="Personal color match level">' +
      '<div class="color-palette__suitability-scale" aria-hidden="true">' +
      '<span>1</span><span>2</span><span>3</span>' +
      '</div>' +
      '</div>' +
      '<p class="color-palette__suitability-value"><strong>' +
      escapeHtml(meta.label) +
      '</strong> � ' +
      escapeHtml(meta.description) +
      '</p>' +
      '</section>'
    );
  }

  function renderStyleSuggestionsField(state) {
    if (!state.outfitsVisible || !state.hasGenerated) return '';

    var value = state.styleSuggestions || '';
    return (
      '<section class="color-palette__feedback" aria-labelledby="color-palette-feedback-heading">' +
      '<h2 id="color-palette-feedback-heading" class="color-palette__feedback-title">Suggest a style</h2>' +
      '<label class="color-palette__feedback-label" for="color-palette-style-suggestions">Which wardrobe styles would you like us to add?</label>' +
      '<textarea id="color-palette-style-suggestions" class="color-palette__feedback-input" data-palette-style-suggestions rows="3" placeholder="e.g. sporty, boho, preppy, vintage...">' +
      escapeHtml(value) +
      '</textarea>' +
      '<div class="color-palette__actions color-palette__feedback-actions">' +
      '<button type="button" class="button button--secondary" data-palette-submit-style-suggestions>Submit suggestion</button>' +
      '</div>' +
      '<p class="color-palette__hint color-palette__feedback-hint hidden" data-palette-style-submit-hint role="status"></p>' +
      '</section>'
    );
  }

  function renderPalettePrompt(config) {
    return (
      '<div class="color-palette__empty-state">' +
      '<p>Build a lockable clothing palette from your color guide profile. Generate shades, keep your favourites, and shuffle the rest.</p>' +
      '<div class="color-palette__actions">' +
      '<a class="button" href="' + escapeHtml(config.palettePageUrl) + '">Build your color palette</a>' +
      '</div>' +
      '</div>'
    );
  }

  function renderCatalogError() {
    return (
      '<div class="color-palette__empty-state">' +
      '<p>We could not load the color catalog. Re-upload the latest <strong>preferences</strong> and <strong>abuja-palette-catalog</strong> snippets to your theme, then refresh this page.</p>' +
      '</div>'
    );
  }

  function renderProfileSummary(context, config) {
    var hair = getAnswerValue(context.answers, 'natural_hair_color');
    var eyes = getAnswerValue(context.answers, 'eye_color');
    var skin = getAnswerValue(context.answers, 'skin_color');
    var modelName =
      context.resolvedModel && context.resolvedModel.name
        ? context.resolvedModel.name
        : context.selectedModel && context.selectedModel.name
          ? context.selectedModel.name
          : '';
    var hasQuizAnswers = !!(hair && eyes && skin);
    var profileNote = '';
    var quizUrl = config && config.quizUrl ? config.quizUrl : '/pages/color-guide';

    if (context.profileSource === 'manual-model') {
      profileNote =
        '<p class="color-palette__profile-note">Using ' +
        escapeHtml(modelName) +
        ' as your stand-in model. <a href="' +
        escapeHtml(quizUrl) +
        '">Take the color guide quiz</a> for hair, skin, and eye matching.</p>';
    } else if (context.quizModelName && modelName) {
      profileNote =
        '<p class="color-palette__profile-note">Outfit previews use ' +
        escapeHtml(modelName) +
        ' (women\u2019s equivalent of your color-guide match, ' +
        escapeHtml(context.quizModelName) +
        ').</p>';
    }

    return (
      '<div class="color-palette__profile">' +
      '<h2 class="color-palette__profile-title">Your color profile</h2>' +
      (hasQuizAnswers
        ? '<dl class="color-palette__profile-list">' +
          '<div><dt>Hair</dt><dd>' + escapeHtml(getAnswerLabel('natural_hair_color', hair)) + '</dd></div>' +
          '<div><dt>Eyes</dt><dd>' + escapeHtml(getAnswerLabel('eye_color', eyes)) + '</dd></div>' +
          '<div><dt>Skin</dt><dd>' + escapeHtml(getAnswerLabel('skin_color', skin)) + '</dd></div>' +
          (modelName
            ? '<div><dt>Closest model</dt><dd>' + escapeHtml(modelName) + '</dd></div>'
            : '') +
          '</dl>'
        : '<p class="color-palette__profile-note">Closest model: <strong>' + escapeHtml(modelName) + '</strong></p>') +
      profileNote +
      '</div>'
    );
  }

  function renderPaletteStrip(slots, hasGenerated, readOnly, suitabilityLevel) {
    if (!hasGenerated) {
      return (
        '<p class="color-palette__hint">' + renderPaletteIntroHint(suitabilityLevel) + '</p>'
      );
    }

    var html =
      '<div class="color-palette__strip" data-color-palette-strip role="list" aria-label="Your clothing color palette">';

    slots.forEach(function (slot, index) {
      var color = slot.color;
      var hex = color ? color.hex : '#cccccc';
      var name = color ? color.name : '-';
      var locked = !!slot.locked;
      var lockLabel = locked ? 'Unlock ' + slot.label : 'Lock ' + slot.label;
      var ratingStars = slot.rating && slot.rating.stars ? slot.rating.stars : 0;
      var roleClass = slotRoleClass(slot.role);
      var roleTag = formatWardrobeRole(slot.assignedWardrobeRole || slot.role);

      html +=
        '<div class="color-palette__slot' +
        (locked && !readOnly ? ' color-palette__slot--locked' : '') +
        (roleClass ? ' ' + roleClass : '') +
        '" role="listitem"' +
        (readOnly ? '' : ' data-slot-index="' + index + '"') +
        '>' +
        (readOnly
          ? ''
          : '<button type="button" class="color-palette__lock" data-palette-lock="' + index + '" aria-pressed="' + (locked ? 'true' : 'false') + '" aria-label="' + escapeHtml(lockLabel) + '">' +
            (locked ? '&#128274;' : '&#128275;') +
            '</button>') +
        '<span class="color-palette__swatch" style="background-color:' + escapeHtml(hex) + '"></span>' +
        '<span class="color-palette__slot-label">' + escapeHtml(slot.label) + '</span>' +
        (roleTag ? '<span class="color-palette__tag">' + escapeHtml(roleTag) + '</span>' : '') +
        (ratingStars
          ? '<span class="color-palette__score" title="' + escapeHtml(slot.rating.label) + '">' + renderStarIcons(ratingStars) + '</span>'
          : '') +
        '<strong class="color-palette__color-name">' + escapeHtml(name) + '</strong>' +
        '</div>';
    });

    html += '</div>';
    return html;
  }

  function renderPalettePreview(slots, hasGenerated) {
    if (!hasGenerated) return '';

    var colors = slots
      .map(function (slot) {
        return slot.color ? slot.color.hex : null;
      })
      .filter(Boolean);

    if (!colors.length) return '';

    var gradient = 'linear-gradient(90deg, ' + colors.join(', ') + ')';
    return (
      '<div class="color-palette__preview" aria-hidden="true">' +
      '<div class="color-palette__preview-bar" style="background:' + gradient + '"></div>' +
      '</div>'
    );
  }

  function renderSavedPaletteSummary(context, state, config, savedAt, savedBanner) {
    var html = '<h3 class="color-palette__result-title">Your saved palette</h3>';

    if (savedBanner) {
      html += '<p class="color-palette__saved-banner" role="status">' + escapeHtml(savedBanner) + '</p>';
    }

    if (savedAt) {
      var date = new Date(savedAt);
      if (!Number.isNaN(date.getTime())) {
        html += '<p class="color-palette__submitted-at">Last updated ' + escapeHtml(date.toLocaleDateString()) + '</p>';
      }
    }

    if (state.styleDirection) {
      html +=
        '<p class="color-palette__submitted-at">Wardrobe style: <strong>' +
        escapeHtml(formatStyleDirection(state.styleDirection)) +
        '</strong></p>';
    }

    html +=
      renderPalettePreview(state.slots, true) +
      renderPaletteStrip(state.slots, true, true, state.suitabilityLevel) +
      '<div class="color-palette__actions">' +
      '<a class="button" href="' + escapeHtml(config.palettePageUrl) + '">Update palette</a>' +
      '<button type="button" class="button button--secondary" data-palette-show-outfits>' +
      (state.outfitsVisible ? 'Refresh outfit previews' : 'See this palette in outfits') +
      '</button>' +
      '</div>' +
      renderOutfitsSection(state, context) +
      renderStyleSuggestionsField(state);

    return html;
  }

  function renderMain(context, state, config) {
    var lockedCount = state.slots.filter(function (slot) {
      return slot.locked;
    }).length;

    return (
      renderProfileSummary(context, config) +
      renderStyleDirectionPicker(state) +
      renderSuitabilitySlider(state) +
      renderPalettePreview(state.slots, state.hasGenerated) +
      renderPaletteStrip(state.slots, state.hasGenerated, false, state.suitabilityLevel) +
      '<div class="color-palette__actions">' +
      '<button type="button" class="button" data-palette-generate>' +
      (state.hasGenerated ? 'Regenerate unlocked colors' : 'Generate palette') +
      '</button>' +
      (state.hasGenerated && lockedCount
        ? '<button type="button" class="button button--secondary" data-palette-unlock-all>Unlock all</button>'
        : '') +
      (state.hasGenerated
        ? '<button type="button" class="button button--secondary" data-palette-show-outfits>' +
          (state.outfitsVisible ? 'Refresh outfit previews' : 'See this palette in outfits') +
          '</button>'
        : '') +
      (state.hasGenerated
        ? '<button type="button" class="button' +
          (lockedCount ? ' button--secondary' : '') +
          '" data-palette-save>Save preferences</button>'
        : '') +
      '</div>' +
      (state.hasGenerated
        ? '<p class="color-palette__hint color-palette__save-hint hidden" data-palette-save-hint></p>'
        : '') +
      (state.hasGenerated && lockedCount === state.slots.length
        ? '<p class="color-palette__hint">All colors are locked. Unlock at least one slot to regenerate.</p>'
        : '') +
      renderOutfitsSection(state, context) +
      renderStyleSuggestionsField(state)
    );
  }

  function bindSavedPaletteEvents(root, context, state, config) {
    if (root.__kailaSavedPaletteBound) return;
    root.__kailaSavedPaletteBound = true;

    root.addEventListener('click', function (event) {
      if (event.target.closest('[data-palette-show-outfits]')) {
        state.outfitsVisible = true;
        var target = root.querySelector('[data-color-palette-saved-content]');
        if (!target) return;

        target.innerHTML = renderSavedPaletteSummary(
          context,
          state,
          config,
          null,
          ''
        );
        mountOutfitGallery(root, context, state, config);
        return;
      }

      if (event.target.closest('[data-palette-submit-style-suggestions]')) {
        handleSubmitStyleSuggestions(root, config, state);
      }
    });

    root.addEventListener('input', function (event) {
      if (event.target.closest('[data-palette-style-suggestions]')) {
        state.styleSuggestions = event.target.value || '';
      }
    });
  }

  function bindPaletteEvents(root, context, state, config) {
    if (root.__kailaPaletteBound) return;
    root.__kailaPaletteBound = true;

    root.addEventListener('click', function (event) {
      var lockBtn = event.target.closest('[data-palette-lock]');
      if (lockBtn) {
        var index = parseInt(lockBtn.getAttribute('data-palette-lock'), 10);
        if (!Number.isFinite(index) || !state.slots[index]) return;
        state.slots[index].locked = !state.slots[index].locked;
        render(root, context, state, config);
        return;
      }

      if (event.target.closest('[data-palette-unlock-all]')) {
        state.slots.forEach(function (slot) {
          slot.locked = false;
        });
        render(root, context, state, config);
        return;
      }

      if (event.target.closest('[data-style-direction]')) {
        var styleBtn = event.target.closest('[data-style-direction]');
        state.styleDirection = styleBtn.getAttribute('data-style-direction') || 'minimal';
        render(root, context, state, config);
        return;
      }

      if (event.target.closest('[data-palette-generate]')) {
        var allLocked = state.slots.every(function (slot) {
          return slot.locked;
        });
        if (state.hasGenerated && allLocked) return;

        if (!state.hasGenerated) {
          state.slots = buildFixedPaletteSlots(context.catalog);
        }

        var candidatePool = buildWardrobeCandidatePool(
          filterVoteColors(context.catalog),
          context.targetProfile
        );
        var engineSlots = prepareSlotsForEngine(state.slots);
        state.slots = generatePalette(
          engineSlots,
          candidatePool,
          context.catalog,
          !state.hasGenerated,
          state.styleDirection,
          state.suitabilityLevel
        );
        refreshSlotRatings(state.slots, context.targetProfile);
        state.hasGenerated = true;
        render(root, context, state, config);
        return;
      }

      if (event.target.closest('[data-palette-show-outfits]')) {
        state.outfitsVisible = true;
        render(root, context, state, config);
        mountOutfitGallery(root, context, state, config);
        return;
      }

      if (event.target.closest('[data-palette-save]')) {
        handleSavePalette(root, config, state);
        return;
      }

      if (event.target.closest('[data-palette-submit-style-suggestions]')) {
        handleSubmitStyleSuggestions(root, config, state);
      }
    });

    root.addEventListener('input', function (event) {
      var suitabilitySlider = event.target.closest('[data-palette-suitability]');
      if (suitabilitySlider) {
        var nextLevel = parseInt(suitabilitySlider.value, 10);
        state.suitabilityLevel = Number.isFinite(nextLevel) ? nextLevel : 1;
        render(root, context, state, config);
        return;
      }

      if (event.target.closest('[data-palette-style-suggestions]')) {
        state.styleSuggestions = event.target.value || '';
      }
    });
  }

  function bindProfileSetupEvents(root, config, catalog) {
    if (root.__kailaProfileSetupBound) return;
    root.__kailaProfileSetupBound = true;

    root.addEventListener('click', function (event) {
      var modelBtn = event.target.closest('[data-palette-model]');
      if (!modelBtn) return;

      var slug = modelBtn.getAttribute('data-palette-model');
      if (!slug) return;

      saveManualModelSelection(config.customerId, slug);
      var model = findModelBySlug(slug);
      var context = buildProfileContextFromModel(model, catalog);
      if (!context) return;

      bootPalettePage(root, config, catalog, context);
    });
  }

  function bootPalettePage(root, config, catalog, context) {
    var target = root.querySelector('[data-color-palette-content]');
    if (!target) return;

    var savedPalette = loadSavedPaletteState(config.customerId);
    var state = savedPalette
      ? hydratePaletteState(savedPalette, catalog)
      : {
          slots: buildFixedPaletteSlots(catalog),
          hasGenerated: false,
          styleDirection: 'minimal',
          suitabilityLevel: 1,
          styleSuggestions: '',
          outfitsVisible: false
        };

    if (context.targetProfile && state.hasGenerated) {
      refreshSlotRatings(state.slots, context.targetProfile);
    }

    render(root, context, state, config);
    bindPaletteEvents(root, context, state, config);
    initPendingPaletteSaveFlow(root, config, context, state, catalog);
  }

  function render(root, context, state, config) {
    var target = root.querySelector('[data-color-palette-content]');
    if (!target) return;
    target.innerHTML = renderMain(context, state, config);
    if (config && state.hasGenerated) {
      savePaletteState(config, state);
    }
    mountOutfitGallery(root, context, state, config);
  }

  function initPreferencesHub() {
    var hub = document.querySelector('[data-preferences-hub]');
    if (!hub) return;

    var guideDone = !!document.querySelector('[data-color-guide-saved-content] .color-guide__rating-groups');
    var voteDone = !!document.querySelector('[data-color-vote-saved-content] .color-vote__result-list');
    var paletteDone = !!document.querySelector('[data-color-palette-saved-content] .color-palette__strip');

    var steps = [
      {
        id: 'guide',
        done: guideDone,
        label: 'Color guide quiz',
        button: 'Take the color guide quiz',
        url: hub.getAttribute('data-quiz-url') || '/pages/color-guide'
      },
      {
        id: 'vote',
        done: voteDone,
        label: 'Color vote',
        button: 'Vote on colors',
        url: hub.getAttribute('data-vote-url') || '/pages/color-vote'
      },
      {
        id: 'palette',
        done: paletteDone,
        label: 'Clothing palette',
        button: 'Build your color palette',
        url: hub.getAttribute('data-palette-url') || '/pages/color-palette'
      }
    ];

    var incomplete = steps.filter(function (step) {
      return !step.done;
    });

    if (!incomplete.length) {
      hub.classList.add('is-hidden');
      hub.innerHTML = '';
      return;
    }

    var items = incomplete.map(function (step) {
      return (
        '<li class="preferences-hub__step">' +
        '<span class="preferences-hub__step-label">' + escapeHtml(step.label) + '</span>' +
        '<a class="button" href="' + escapeHtml(step.url) + '">' + escapeHtml(step.button) + '</a>' +
        '</li>'
      );
    }).join('');

    hub.innerHTML =
      '<p class="preferences-hub__intro">Complete these steps to build your full color profile.</p>' +
      '<ul class="preferences-hub__steps">' + items + '</ul>';
    hub.classList.remove('is-hidden');
  }

  function schedulePreferencesHub() {
    if (typeof requestAnimationFrame === 'function') {
      requestAnimationFrame(initPreferencesHub);
    } else {
      initPreferencesHub();
    }
  }

  window.kailaRefreshPreferencesHub = schedulePreferencesHub;

  function initSavedPalettePage() {
    var root = document.querySelector('[data-color-palette-saved]');
    if (!root) return;

    var target = root.querySelector('[data-color-palette-saved-content]');
    if (!target) return;

    var config = getConfig(root);

    if (!config.loggedIn) {
      target.innerHTML = renderLoginPrompt(config);
      schedulePreferencesHub();
      return;
    }

    var guidePayload = loadColorGuideData(config);
    var manualModelSlug = loadManualModelSelection(config.customerId);
    var savedPalette = loadSavedPaletteState(config.customerId);
    if (!savedPalette) {
      target.innerHTML = renderPalettePrompt(config);
      schedulePreferencesHub();
      return;
    }

    loadCatalog(config)
      .then(function (catalog) {
        var context = resolveProfileContext(guidePayload, manualModelSlug, catalog);
        if (!context) {
          target.innerHTML = renderPalettePrompt(config);
          schedulePreferencesHub();
          return;
        }

        var state = hydratePaletteState(savedPalette, catalog);
        refreshSlotRatings(state.slots, context.targetProfile);
        state.outfitsVisible = true;
        var params = new URLSearchParams(window.location.search);
        var savedBanner = params.get('palette_saved') === '1' ? 'Your palette has been saved.' : '';
        target.innerHTML = renderSavedPaletteSummary(
          context,
          state,
          config,
          savedPalette.savedAt || savedPalette.saved_at,
          savedBanner
        );
        bindSavedPaletteEvents(root, context, state, config);
        mountOutfitGallery(root, context, state, config);
        if (params.get('palette_saved') === '1') {
          try {
            var cleanUrl = window.location.pathname + window.location.search
              .replace(/([?&])palette_saved=1&?/, '$1')
              .replace(/([?&])local=1&?/, '$1')
              .replace(/[?&]$/, '');
            window.history.replaceState({}, '', cleanUrl || window.location.pathname);
          } catch (e) {}
        }
        schedulePreferencesHub();
      })
      .catch(function () {
        target.innerHTML = renderCatalogError();
        schedulePreferencesHub();
      });
  }

  function initPendingPaletteSaveFlow(root, config, context, state, catalog) {
    var params = new URLSearchParams(window.location.search);
    if (params.get(PALETTE_AUTO_SAVE_PARAM) !== '1') return;
    if (!config.loggedIn) return;

    var pending = readPendingPaletteSave();
    if (pending && pending.palette) {
      var hydrated = hydratePaletteState(pending.palette, catalog);
      state.hasGenerated = hydrated.hasGenerated;
      state.slots = hydrated.slots;
      render(root, context, state, config);
    } else if (!state.hasGenerated) {
      return;
    }

    handleSavePalette(root, config, state);

    try {
      var cleanUrl = window.location.pathname + window.location.search
        .replace(/([?&])color_palette_auto_save=1&?/, '$1')
        .replace(/[?&]$/, '');
      window.history.replaceState({}, '', cleanUrl || window.location.pathname);
    } catch (e) {}
  }

  function initPalettePage() {
    var root = document.querySelector('[data-color-palette-root]');
    if (!root) return;

    var config = getConfig(root);
    var target = root.querySelector('[data-color-palette-content]');
    if (!target) return;

    if (!config.loggedIn) {
      target.innerHTML = renderLoginPrompt(config);
      return;
    }

    var guidePayload = loadColorGuideData(config);
    var manualModelSlug = loadManualModelSelection(config.customerId);

    loadCatalog(config)
      .then(function (catalog) {
        var context = resolveProfileContext(guidePayload, manualModelSlug, catalog);
        if (!context) {
          target.innerHTML = renderProfileSetup(config);
          bindProfileSetupEvents(root, config, catalog);
          return;
        }

        bootPalettePage(root, config, catalog, context);
      })
      .catch(function () {
        target.innerHTML = renderCatalogError();
      });
  }

  ready(function () {
    initPalettePage();
    initSavedPalettePage();
  });
})();
